import { useLocalizedControl } from "../../model/localized-value-control-context";
import { OpenFullLocalizationButton } from "../open-full-localization-button/open-full-localization-button";

import { LocaleFormItem } from "../locale-form-item/locale-form-item";

export function ShortView() {
  const { currentLanguages, languages } = useLocalizedControl();

  return (
    <div>
      <div className="flex space-x-2">
        <div className="grow">
          {languages.map((locale) => {
            const isChosenLocale = locale === currentLanguages;

            return (
              <LocaleFormItem
                key={locale}
                locale={locale}
                hidden={!isChosenLocale}
              />
            );
          })}
        </div>
        <div className="pt-[30px]">
          <OpenFullLocalizationButton />
        </div>
      </div>
    </div>
  );
}
